import { BaseSetting } from './base-setting.model';
import { KeyValuePair } from './key-value-pair.model';

export class GeneralSettingsDao extends BaseSetting {
  constructor(settings: KeyValuePair[]) {
    super(settings);

    this.paginationSize = this.getValue<number>('generalPaginationSize', 10);
  }

  paginationSize: number;

  public override getSettings(): KeyValuePair[] {
    if (!this.paginationSize || this.paginationSize < 1) {
      this.paginationSize = 10;
    }
    return [new KeyValuePair('generalPaginationSize', JSON.stringify(this.paginationSize))];
  }
}
